export default {
    name: 'notify',
    path: 'notify',
    component: () => import('@/pages/notify/Index'),
    meta: { title: '消息通知' }
}
